import React, { useEffect, useState, useRef } from 'react';
import { Box, SimpleGrid, useToast, Flex, Button } from '@chakra-ui/react';
import DynamicTable from '../../../components/table/DynamicTable.js';
import { columnsDataStudies } from './variables/columnsDataStudies.js';
import { getData, postData, deleteData } from '../../../utils/httpClient.js';
import { useSearch } from '../../../contexts/SearchContext.js';
import CreateModal from '../../../components/study/CreateModal.js';
import ConfirmModal from '../../../components/modal/ConfirmModal.js';

const initialFormData = {
  id: '',
  description: '',
  studyTypeId: '',
  studyTypeDescription: '',
  createdBy: 0,
  updatedBy: 0,
  createdDate: '',
  updatedDate: '',
  enabled: false
};

export default function Settings() {
  const { searchQuery, updateSearchQuery } = useSearch();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [modalState, setModalState] = useState({
    isOpen: false,
    confirmModalOpen: false,
  });

  const [formData, setFormData] = useState(initialFormData);

  const rowsPerPage = 10;
  const toast = useToast();

  const latestRequestRef = useRef(0);

  const getStudies = async (dato) => {
    const requestId = ++latestRequestRef.current;
    try {
      const response = await getData(
        `/study?page=${page + 1}&limit=${rowsPerPage}&data=${dato}`,
      );

      if (requestId !== latestRequestRef.current) return;
      console.log(response);
      setData(response?.payload?.studies || []);
      setTotalPages(Math.ceil(response?.payload?.total / rowsPerPage));
    } catch (error) {
      if (requestId !== latestRequestRef.current) return;
      toast({
        title: 'Error al obtener estudios',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const createPostData = (formData) => {
    return {
      description: formData.description,
      studyTypeId: formData.studyTypeId,
    };
  };

  const createStudy = async () => {
    try {
      const newStudy = createPostData(formData);
      const response = await postData('/study', newStudy);
      if (response?.payload) {
        toast({
          title: 'Estudio creado con éxito',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        closeModal();
      }
    } catch (error) {
      toast({
        title: 'Error al crear estudio',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    getStudies(searchQuery);
  }, [page, searchQuery]);

  const resetForm = () => {
    setFormData(initialFormData);
  };

  const openModal = () => {
    setModalState({
      isOpen: true,
      confirmModalOpen: false,
    });
  };

  const closeModal = () => {
    setModalState({
      isOpen: false,
      confirmModalOpen: false,
    });
    resetForm();
  };

  const showConfirmModal = () => {
    setModalState({
      isOpen: true,
      confirmModalOpen: true,
    });
  };

  const hiddeConfirmModal = () => {
    setModalState({
      isOpen: true,
      confirmModalOpen: false,
    });
  };

  const handleConfirm = async () => {

    await createStudy();
    await getStudies('');
  };

  const removeStudy = async (row) => {
    const label = row.description || `estudio ${row.id}`;
    if (!window.confirm(`¿Eliminar "${label}"? Deja de verse en el listado para poder cargar las carreras de nuevo.`)) {
      return;
    }
    try {
      await deleteData(`/study/${row.id}`);
      toast({
        title: 'Estudio eliminado',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      await getStudies(searchQuery);
    } catch (error) {
      toast({
        title: 'Error al eliminar el estudio',
        description: error?.message,
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }
  };

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <Flex justify="flex-end" mb={4} gap={3}>
        <Button
          variant="outline"
          colorScheme="red"
          onClick={async () => {
            if (!window.confirm('¿Eliminar todas las carreras y cursos del listado para empezar de cero?')) return;
            try {
              await deleteData('/study/all');
              toast({ title: 'Estudios eliminados', status: 'success', duration: 3000, isClosable: true });
              await getStudies(searchQuery);
            } catch (error) {
              toast({
                title: 'Error al eliminar los estudios',
                description: error?.message,
                status: 'error',
                duration: 4000,
                isClosable: true,
              });
            }
          }}
        >
          Eliminar todas
        </Button>
        <Button colorScheme="blue" onClick={() => openModal()}>
          Nuevo Estudio
        </Button>
      </Flex>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1 }}
        spacing={{ base: '20px', xl: '20px' }}
      >
        <DynamicTable
          columnsData={columnsDataStudies}
          data={data}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          openModal={openModal}
          onDelete={removeStudy}
        />
      </SimpleGrid>

      <CreateModal
        isOpen={modalState.isOpen}
        onClose={showConfirmModal}
        formData={formData}
        setFormData={setFormData}
        onConfirm={handleConfirm}
      />

      <ConfirmModal
        isOpen={modalState.confirmModalOpen}
        onClose={hiddeConfirmModal}
        onConfirm={closeModal}
        header="Confirmación de Cancelación"
        message="¿Estás seguro de que deseas cancelar? Todos los datos no guardados se perderán."
      />
    </Box>
  );
}
